import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import cx from 'classnames';
import { ReactComponent as AgentIcon } from '../../design-system/design_system/assets/icons/system/live-chat.svg';

const ChatAEM = (props) => {
  const {
    onlineButtonId,
    reactiveButtonId,
    offlineButtonId,
  } = props;

  const [chatReady, setChatReady] = useState(false);

  useEffect(() => {
    if (!window._laq) window._laq = [];
    window._laq.push(() => {
      console.log('LiveAgent is now initialized, enabling chat button.');
      setChatReady(true);
    });
  }, []);

  const handleChatClick = () => {
    if (window.liveagent && chatReady) {
      window.liveagent.startChat(reactiveButtonId);
    } else {
      console.warn('LiveAgent is not ready yet!');
    }
  };



  return (
    <section id="c2c-container" className="c2cImgClass chat-container shadow-2">
      <Button
        id={onlineButtonId}
        variant="primary"
        className={cx('border-0 chat-icon bg-primary', { 'd-none': !reactiveButtonId || window.isChatOffline })}
   //     onClick={() => window.liveagent && window.liveagent.startChat(reactiveButtonId)}
        onClick={handleChatClick}
        data-testid={onlineButtonId}
        aria-label="Click To Chat Label"
      >
        <AgentIcon className="agent-icon svg-fill-white" />
        <span className="live-chat p-2">{get(JSON.parse(localStorage.getItem('_liveChat')), 'liveChatOnline', '')}</span>
      </Button>
      <Button
        id={offlineButtonId}
        variant="primary"
        className="border-0 chat-icon d-none bg-primary"
        style={{ display: 'none' }}
        data-testid={offlineButtonId}
      >
        <AgentIcon className="agent-icon svg-fill-white" />
        <span className="live-chat p-2">
          {get(JSON.parse(localStorage.getItem('_liveChat')), 'liveChatOnline', '')}
        </span>
      </Button>
    </section>
  );
};

ChatAEM.propTypes = {
  onlineButtonId: PropTypes.string.isRequired,
  offlineButtonId: PropTypes.string.isRequired,
  reactiveButtonId: PropTypes.string.isRequired,
};

export default ChatAEM;
